export default __webpack_public_path__ + "static/media/1514.78b4c861.png";